<template>
  <div class="info">
    <h1 class="info__title">Adaptability</h1>

    <dots-number activeDots='3'/>

    <div class="info text-center">
      <div class="info__header">
        <img class="info__img" src="/static/img/Adaptability.svg" alt="">
        <p class="info__header-text">
           The organisation seeks, anticipates and welcomes change, embracing a state of ongoing flux as the
           ‘new normal’. As the pace of 21st century change accelerates, the organisation employs ways
           of working that proactively anticipate potential adjustments, ensuring its flexibility and
           nimbleness to adapt at pace.
        </p>
      </div>

      <div class="info__footer">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import DotsNumber from '@/components/Evaluation/Dots';

export default {
  components: { DotsNumber },
  data() {
    return {
      id: 2,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/Dynamism/Info.vue